export default {
  CLOSE: 'closeContextMenu',
  ERROR: 'contextMenuError',
  READY_ELEMENT_POSITION: 'readyElementPosition',
  PLAY_AUDIO: 'playAudio',
  EDIT_NOTE: 'editNote',
  ADD_NOTE: 'addNote',
  DELETE_NOTE: 'deleteNote',
  TRANSLATE: 'translate',
  LOOKUP: 'lookup',
  BOOKMARK: 'bookmark',
  COPY: 'copy',
  SHARE: 'share',
  REOPEN: 'reopen',
  ADD_PARA_NOTE: 'addParaNote',
  ADD_ESSAY_TASK: 'addEssayTask',
  ADD_QUIZ_TASK: 'addQuizTask',
  ADD_FLASHCARD_TASK: 'addFlashcardTask',
  RESET_READING: 'resetReading',
  OPEN_CORRECTION_LINK: 'openCorrectionLink',
  CREATE_REPORT: 'createReport',
  ADD_SELECTION_TO_COMPILATION: 'addSelectionToCompilation',
  OPEN_TYPO_POPUP: 'typoPopup',
  OPEN_SOCIAL_SHARING_POPUP: 'openSocialSharingPopup',
  OPEN_CREATE_BLOG_POST_POPUP: 'openCreateBlogPostPopup'
};
